// [VexFlow](https://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
// MIT License
import { CommonMetrics } from '../src/fonts/common_metrics';
import { PetalumaFont } from '../src/fonts/petaluma_glyphs';
export const Font = {
    data: PetalumaFont,
    metrics: CommonMetrics,
};
export default Font;
